import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  IShift,
  IShiftInfoDTO,
  IUserInfoDetailsDTO,
  IUserPfEsiDetailsDTO,
} from '@bashaquerizwan/azaadi-packages';
import { Observable } from 'rxjs';
import { IGenericResponse } from 'src/app/modules/home/pages/dashboard/models/Generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly _http = inject(HttpClient);
  private readonly _userUrl = environment.apiUserUrl;
  private readonly _baseUrl = environment.apiBaseUrl;

  getUserDetailsApiService(): Observable<
    IGenericResponse<IUserInfoDetailsDTO>
  > {
    return this._http.get<IGenericResponse<IUserInfoDetailsDTO>>(
      `${this._userUrl}/profile-details`,
    );
  }

  getPfEsiDetailsApiService(): Observable<
    IGenericResponse<IUserPfEsiDetailsDTO>
  > {
    return this._http.get<IGenericResponse<IUserPfEsiDetailsDTO>>(
      `${this._userUrl}/pf-esi-details`,
    );
  }

  getDocumentsApiService(): Observable<IGenericResponse<any[]>> {
    return this._http.get<IGenericResponse<any>>(
      `${this._baseUrl}/documents/user`,
    );
  }

  updateUserApiService(requestBody: any): Observable<IGenericResponse<any>> {
    return this._http.patch<IGenericResponse<any>>(
      `${this._userUrl}/update`,
      requestBody,
    );
  }

  getShiftByUserIdApiService(): Observable<IGenericResponse<IShiftInfoDTO[]>> {
    return this._http.get<IGenericResponse<IShiftInfoDTO[]>>(
      `${this._baseUrl}/shift/by-user`,
    );
  }
}
